import { useEffect, useState, useCallback } from 'react'
import { createPortal } from 'react-dom'
import PropTypes from 'prop-types'
import { cn } from 'lib/utils'

const PLACEMENT_MAP = {
  bottom: (r) => ({ top: r.bottom + 8, left: r.left }),
  'bottom-start': (r) => ({ top: r.bottom + 8, left: r.left }),
  'bottom-end': (r) => ({ top: r.bottom + 8, left: r.right, transform: 'translateX(-100%)' }),
  top: (r) => ({ top: r.top - 8, left: r.left, transform: 'translateY(-100%)' }),
  'top-start': (r) => ({ top: r.top - 8, left: r.left, transform: 'translateY(-100%)' }),
  'top-end': (r) => ({ top: r.top - 8, left: r.right, transform: 'translate(-100%, -100%)' }),
  left: (r) => ({ top: r.top, left: r.left - 8, transform: 'translateX(-100%)' }),
  right: (r) => ({ top: r.top, left: r.right + 8 })
}

export const AdasPopper = ({ open, anchorEl, children, placement = 'bottom', className, sx, ...props }) => {
  const [style, setStyle] = useState({})

  const updatePosition = useCallback(() => {
    if (!open || !anchorEl) return
    const rect =
      typeof anchorEl.getBoundingClientRect === 'function' ? anchorEl.getBoundingClientRect() : anchorEl.current?.getBoundingClientRect?.()
    if (!rect) return
    const positionFn = PLACEMENT_MAP[placement] || PLACEMENT_MAP.bottom
    setStyle({ position: 'fixed', zIndex: 1300, ...positionFn(rect) })
  }, [open, anchorEl, placement])

  useEffect(() => {
    updatePosition()
  }, [updatePosition])

  useEffect(() => {
    if (!open) return
    window.addEventListener('scroll', updatePosition, true)
    window.addEventListener('resize', updatePosition)
    return () => {
      window.removeEventListener('scroll', updatePosition, true)
      window.removeEventListener('resize', updatePosition)
    }
  }, [open, updatePosition])

  if (!open) return null
  return createPortal(
    <div style={style} className={cn('bg-card rounded-card shadow-xl border border-border', className)} {...props}>
      {children}
    </div>,
    document.body
  )
}

AdasPopper.propTypes = {
  open: PropTypes.bool,
  anchorEl: PropTypes.oneOfType([PropTypes.object, PropTypes.func]),
  children: PropTypes.node,
  placement: PropTypes.string,
  className: PropTypes.string
}
